// form Bonpreu
export const FORM_BP = 'BP';

// form consumo
export const FORM_CONSUMO = 'C';

// form Repsol
export const FORM_REPSOL = 'REP';

// form GS
export const FORM_GS = 'GS';

// form Mango no shopping
export const FORM_MG_NO_SHOP = 'MG-NS';

// form Mango
export const FORM_MG = 'MG';

// form auto
export const FORM_AUTO = 'AUTO';

//form IC
export const FORM_IC = 'IC';

// forms components
export const POINT_OF_SALE = 0;
export const REQUEST_DATA = 1;
export const REQUEST_BASIC_CONTACT = 2;
export const HOLDER_DATA = 3;
export const CONTACT_DATA = 4;
export const SOCIOECONOMIC_DATA = 5;
export const INSURANCE = 6;
export const DIRECT_DEBIT = 7;
export const REQUEST_OBSERVATIONS = 8;
export const FINANCE = 9;
export const REQUEST_DATA_MG = 10;
export const FINANCE_AMOUNT = 11;
export const PRESCRIBER_CONTACT_DATA = 12;

export const INTERVINIENTE_1_HOLDER_DATA = 13;
export const INTERVINIENTE_1_CONTACT_DATA = 14;
export const INTERVINIENTE_1_SOCIOECONOMIC_DATA = 15;
export const INTERVINIENTE_1_DIRECT_DEBIT = 16;
export const INTERVINIENTE_2_HOLDER_DATA = 17;
export const INTERVINIENTE_2_CONTACT_DATA = 18;
export const INTERVINIENTE_2_SOCIOECONOMIC_DATA = 19;
export const INTERVINIENTE_2_DIRECT_DEBIT = 20;
export const INTERVINIENTE_3_HOLDER_DATA = 21;
export const INTERVINIENTE_3_CONTACT_DATA = 22;
export const INTERVINIENTE_3_SOCIOECONOMIC_DATA = 23;
export const INTERVINIENTE_3_DIRECT_DEBIT = 24;
export const INTERVINIENTE_4_HOLDER_DATA = 25;
export const INTERVINIENTE_4_CONTACT_DATA = 26;
export const INTERVINIENTE_4_SOCIOECONOMIC_DATA = 27;
export const INTERVINIENTE_4_DIRECT_DEBIT = 28;

export const TOTAL_FORM_NO_INTERVINIENTS = 13;
export const TOTAL_FORM_1_INTERVINIENTS = 17;
export const TOTAL_FORM_2_INTERVINIENTS = 21;
export const TOTAL_FORM_3_INTERVINIENTS = 25;
export const TOTAL_FORM_4_INTERVINIENTS = 28;

//Modalidad de pago
export const MODALITY_PAYMENT_CUOTA_FIJA = '14';
export const MODALITY_PAYMENT_FIN_MES = '11';

//Situación Laboral
export const WORK_SITUATION_AUTONOMO = '04';
export const WORK_SITUATION_PERMANENT = '01';
export const WORK_SITUATION_TEMPORARY = '02';
export const WORK_SITUATION_OFFICIAL = '03';
export const WORK_SITUATION_TEMPORERO = '09';
export const WORK_SITUATION_BECARIO = '05';
export const WORK_SITUATION_PARADO = '06';
export const WORK_SITUATION_JUBILADO = '07';
export const WORK_SITUATION_PENSIONISTA = '08';
export const WORK_SITUATION_NO_TRABAJA = '14';

//Productos financieros
export const FINANCIAL_PRODUCT_MG = '30';
export const FINANCIAL_PRODUCT_C = '10';
export const FINANCIAL_PRODUCT_AUTO = '20';

//Requests status
export const PENDIENTES_DE_DATOS = '00';
export const APROBADAS = 'PA';
export const EN_ESTUDIO = 'PE';
export const DENEGADAS = 'DN';
export const DENEGADAS_NOFINAL = '07';
export const ABONADAS_PENDIENTES_DE_VALIDACION = 'PV';
export const FORMALIZADAS_ABONADAS_VALIDADAS = '90';
export const ANULADAS = '95';
export const PENDIENTES_PAGO_POR_INCIDENCIAS = '15';
export const CONDICIONADA_PENDIENTE_DE_FORMALIZACION = '35';
export const FIRMADAS = 'PF';
export const FIRMADAS_STATUS_75 = 'FI';

// validations file

// 15MB
export const MAX_SIZE_FILE = 15728640;
// 25MB
export const MAX_TOTAL_SIZE = 26214400;

// type
export const TYPE_FILE_ALLOWED = [
  'image/jpeg',
  'application/pdf',
  'image/png',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

//We need to specific this formats due to image/jpeg and image/tiff defining other extensions aside from the ones accepted
//https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
export const IMAGE_FORMAT_FILES_NOT_ALLOWED = ['.jfif', '.jif', '.jpe', '.tif'];

//We need to specific this formats due to application/msword supporting other extensions aside from the ones accepted
//https://mimetype.io/application/msword
export const MSWORD_FORMAT_FILES_NOT_ALLOWED = ['.dot', '.wiz', '.rtf'];
export const OPENXML_FORMAT_FILES_NOT_ALLOWED = ['.dotx ', '.docm ', '.dotm '];

export const IMAGE_FILE_ALLOWED = ['image/jpeg', 'image/png'];

//Seguros
export const ASSURANCE_LIFE_VA = 'VA';
export const ASSURANCE_LIFE_VF = 'VF';
export const ASSURANCE_LIFE_VP = 'VP';

export const ASSURANCE_TOTAL_PROTECTION_PA = 'PA';
export const ASSURANCE_TOTAL_PROTECTION_PC = 'PC';

export const ASSURANCE_MIN_AGE = 18;
export const ASSURANCE_LIFE_MAX_AGE = 70;
export const ASSURANCE_TOTAL_MAX_AGE = 65;
export const ASSURANCE_PAYMENT_MAX_AGE = 65;

//Modes
export const REQUEST_MODE_NEW = 'new';
export const REQUEST_MODE_VIEW = 'view';
export const REQUEST_MODE_EDIT = 'edit';

//Languages
export const LANGUAGE_SPANISH = 'ES';
export const LANGUAGE_CATALAN = 'CA';

//Input Channels
export const INPUT_CHANNEL_TELEPHONE = 'OL';
export const INPUT_CHANNEL_FORM = 'FO';

export const CONSTANTE_ID_COMBO_COTITULAR = '1';

export const INTERVINIENTE_TITULAR = 'T';
export const INTERVINIENTE_AVALISTA = 'A';
export const INTERVINIENTE_COTITULAR = 'C';

export const MAX_INCOME_DIALOG = 5000;

export const REQUEST_APPROVED = 'PA';
export const REQUEST_PENDING = '00';
export const REQUEST_STUDYING = 'PE';
export const REQUEST_DENIED = 'DN';
export const REQUEST_PAID_PENDING_VALIDATION = 'PV';
export const REQUEST_REGULARISE_PAID_VALIDATED = '90';
export const REQUEST_CONDTIONATED_VALIDATION = '35';
export const REQUEST_CANCELLED = '95';
export const REQUEST_PENDING_PAYMENT_INCIDENT = '15';
export const REQUEST_SIGNED = 'PF';
export const REQUEST_CONDITIONED_PENDING_FORMALIZATION = '35';

export const REQUEST_STEPPER_1 = 0;
export const REQUEST_STEPPER_2 = 1;
export const REQUEST_STEPPER_3 = 2;

export const BRAND_PAPYRUS_CONSUMO = 'PRESTAMO_CONSUMO';
export const BRAND_PAPYRUS_CREDICUENTAS = 'TARJETA_CUENTAS_CRED';
export const BRAND_PAPYRUS_PRESTAMO_PERSONAL = 'PRESTAMO_PERSONAL';
export const BRAND_PAPYRUS_PRESTAMO_REESTRUCTURADO = 'PRESTAMO_REESTRUCTURADO';
export const BRAND_CONSUMO = 'CONSUMO';
export const BRAND_AUTOS = 'AUTOS';
export const BRAND_AUTOS_LEASING = 'LEASING';
export const BRAND_MANGONS = 'MANGONS';
export const BRAND_MANGO = 'MANGO';
export const BRAND_TARJETA = 'TARJETA';

//BALANCE IC
export const TYPE_BALANCE_T = 'T';
export const TYPE_BALANCE_N = 'N';
export const TYPE_BALANCE_S = 'S';

export const OPERATIVE_EIC = 'EIC';
export const OPERATIVE_ESC = 'ESC';

export const VEHICLE_USED = 'U';

export const VERSION_PRESTAMO_REESTRUCTURADO = 'V8';

export const VALUE_TRUE = 'S';

// STATUS HOST WEB

export const HostCodes = {
  PENDING_SCORING: '00', // PENDIENTE DE SCORING
  IN_COMPLIANCE_STUDY: '03', // EN ESTUDIO POR CUMPLIMIENTO NORMATIVO
  PENDING_CONTRACT: '05', // PENDIENTE DE CONTRATO
  PENDING_STUDY: '06', // PENDIENTE DE ESTUDIO
  DENIED: '07', // DENEGADA
  NOT_VALIDATED: '08', // PAGADA NO VALIDADA
  PENDING_SIGNED_CONTRACT: '10', // PENDIENTE CONTRATO FIRMADO
  PAID_PENDING_SIGNED_CONTRACT: '11', // PAGADA PENDIENTE CONTRATO FIRMADO
  APPROVED_PENDING_ANTI_FRAUD: '14', // APROBADA PENDIENTE ANTI-FRAUDE
  PENDING_TITULAR_JUSTIFICANTS: '15', // PENDIENTE JUSTIFICANTES TITULAR
  PAID_PENDING_TITULAR_JUSTIFICANTS: '16', // PAGADA PENDIENTE JUSTIFICANTES TITULAR
  FRAUD_OK: '18', // FRAUDE OK
  APPROVED_PENDING_JUSTIFICANTS_AND_REFERENCES: '19', // APROBADA PTE. JUSTIFICANTES Y REFERENCIAS
  PENDING_COTITULAR_JUSTIFICANTS: '20', // PENDIENTE JUSTIFICANTES COTITULAR
  PAID_PENDING_COTITULAR_JUSTIFICANTS: '21', // PAGADA PENDIENTE JUSTIFICANTES COTITULAR
  DOC_OK_PENDING_SIGNATURE: '25', // DOC OK PTE FIRMA
  PAID_PENDING_ADEQUATE_JUSTIFICANTS: '26', // PAGADA PENDIENTE JUSTIFICANTES AVALISTA
  OPERATION_ASSIGNED_BY_RISKS: '27', // OPERACIÓN ASIGNADA POR RIESGOS
  SENT_LINK_FOR_SIGNATURE: '30', // ENVIADO LINK PARA FIRMA
  PAID_PENDING_COMPRAS_JUSTIFICANTS: '31', // PAGADA PENDIENTE JUSTIFICANTES COMPRA
  PENDING_GOOD_DELIVERY: '35', // PENDIENTE ENTREGA DEL BIEN
  DATA_STUDY_PENDING: '40', // ESTUDIO PENDIENTE DE DATOS
  AVALISTA_STUDY_PENDING: '41', // ESTUDIO PTE. AVALISTA
  GUARANTEES_STUDY_PENDING: '42', // ESTUDIO PTE. GARANTIAS
  REFERENCES_STUDY_PENDING: '43', // ESTUDIO POR REFERENCIAS
  REGISTRIES_STUDY_PENDING: '44', // ESTUDIO PTE. REGISTROS
  PAID_PENDING_ANTI_FRAUD_REFERENCES: '66', // PAGADA PTE. REF. ANTI-FRAUDE
  PAID_PENDING_VARIOUS_TITULAR_JUSTIFICANTS: '67', // PAGADA PTE. JUSTIFICANTES VARIOS TITULARES
  PAID_PENDING_JUSTIFICANTS_AND_REFERENCES: '68', // PAGADA PTE. JUSTIFICANTE Y REFERENCIAS
  PAID_CONTRACT_DOCUMENTATION_WITH_INCIDENTS: '69', // PAGADA CONTRATO DOCUMENTACION CON INCIDENCIAS
  MANUAL_DOUT: '70', // DUDA MANUAL
  SIGNED: '75', // FIRMADA
  FORMALIZED: '90', // FORMALIZADA
  OPERATION_CANCELED: '95', // OPERACION ANULADA
  AUTOMATIC_DENIAL: '97', // DENEGACION AUTOMATICA
  OPERATION_CANCELED_2: '98', // OPERACION ANULADA
};

export const DOCUMENTO_APORTADO = 'A';

export const DOCUMENTO_INCIDENCIA = 'I';

export const DOCUMENTO_NO_APORTADO = 'F';

export const DOCUMENTO_NO_APLICA = 'V';

export const CAPTACION_CANAL = {
  IT: 'IT',
  WS: 'WS',
  GLOBAL_CREDIT: 'WB',
  OPTIM_CREDIT_OF: 'OF',
  OPTIM_CREDIT_OC: 'OC',
  APP_AE: 'AE',
  APP_AP: 'AP',
  MANGO_FO: 'FO',
  MANGO_OL: 'OL',
  TELEFONO_FX: 'FX',
  TELEFONO_TE: 'TE',
  TELEFONO_ON: 'ON',
  IC_EC: 'IC',
  IC_STORE: 'IF',
  BP_MNG: 'IN',
  BP_QUIOSCO: 'IQ',
  IC_TPV: 'TP',
  PRESCRIPTORES: 'WC',
  IC_WS: 'WI',
  IC_GC: 'IB',
};
